import { render, staticRenderFns } from "./Step3CancelInsurance.vue?vue&type=template&id=047858c2&"
import script from "./Step3CancelInsurance.vue?vue&type=script&lang=js&"
export * from "./Step3CancelInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports